import { extendTheme } from '@chakra-ui/react';
import { createBreakpoints } from '@chakra-ui/theme-tools';

// 2. Update the breakpoints as key-value pairs
const breakpoints = createBreakpoints({
	sm: '30em',
	md: '48em',
	lg: '62em',
	xl: '80em',
	xxl: '100em',
	xxxl: '120em',
	xxxxl: '140em'
});

const defaultScheme = 'blue';

// Extending/Customising default theme
export const overridetheme = extendTheme({
	breakpoints,
	shadows: {},
	components: {
		Button: {
			defaultProps: {
				colorScheme: defaultScheme,
				size: 'sm',
				variant: 'outline'
			}
		},

		Input: {
			baseStyle: { height: '1.75rem' },
			defaultProps: {
				focusBorderColor: `${defaultScheme}.500`,
				colorScheme: defaultScheme,
				size: 'sm',
				variant: 'filled'
			}
		},
		Select: {
			defaultProps: {
				focusBorderColor: `${defaultScheme}.500`,
				colorScheme: defaultScheme,
				size: 'sm',
				variant: 'filled'
			}
		},
		IconButton: {
			defaultProps: {
				colorScheme: defaultScheme,
				size: 'sm'
			}
		},
		FormLabel: {
			baseStyle: { marginBottom: '.2rem', fontSize: 'sm' }
		},
		Radio: {
			defaultProps: {
				colorScheme: defaultScheme,
				size: 'sm'
			}
		}
	},
	styles: {
		global: {
			body: {
				width: '100%',
				fontFamily: '"Montserrat", Calibri, Helvetica, Sans'
				// color: '#333'
			},
			'a.active': {
				color: 'teal.500',
				background: 'teal.100',
				_hover: {
					textDecoration: 'none'
				}
			}
		}
	}
});
